import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-create-groups',
  templateUrl: './edit-create-groups.component.html',
  styleUrls: ['./edit-create-groups.component.scss']
})
export class UnidadesEditCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
